<template>
  <component
    class="flex items-center gap-3.5"
    :class="size"
    :is="tag"
    v-bind="$attrs"
  >
    <div
      class="bg-[#807B7A2E] rounded-full cursor-pointer flex items-center justify-center size-9"
    >
      <div v-html="iconSvg"></div>
    </div>
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
interface Props {
  tag?: string
  icon?: 'arrowBack' | 'close'
}

const props = withDefaults(defineProps<Props>(), {
  tag: 'button',
  icon: 'close',
})

defineOptions({
  inheritAttrs: false,
})

const icons = {
  arrowBack:
    '<svg width="16" height="14" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0" aria-hidden="true"><path d="M15.812 7a.938.938 0 0 1-.937.938H3.39l4.025 4.025a.94.94 0 1 1-1.328 1.328L.462 7.666a.938.938 0 0 1 0-1.328L6.087.713A.94.94 0 0 1 7.415 2.04L3.39 6.063h11.485a.938.938 0 0 1 .937.938Z" fill="currentColor"/></svg>',
  close:
    '<svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0" aria-hidden="true"><path d="M16.289 15.461a.939.939 0 1 1-1.328 1.328L10 11.827l-4.962 4.96A.94.94 0 0 1 3.71 15.46l4.961-4.96-4.96-4.961A.94.94 0 1 1 5.04 4.209L10 9.171l4.962-4.962a.94.94 0 1 1 1.328 1.328l-4.961 4.962 4.96 4.962Z" fill="currentColor"/></svg>',
}

const iconSvg = computed(() => icons[props.icon])
</script>
